module.exports = __webpack_public_path__ + "img/triangle-55.b574eac4.gif";